"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE_TO_WIDTH = void 0;
exports.SIZE_TO_WIDTH = {
    'sm': '256px',
    'md': '288px',
    'lg': '320px',
    'xl': '352px',
};
